'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

exports.default = (0, _immutable.Record)({
  history: new _immutable.OrderedSet(),
  startTime: null,
  endTime: null
}, 'ChatHistory');
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-1.79/js/records/ChatHistory.js
// module id = 53
// module chunks = 0 1